import React from "react";
import { useIntl } from "react-intl";

import { AsyncWithSearch } from "../../AsyncSelect";

function SelectOrigem(props) {
  const intl = useIntl();
  const URL = "/api/pipeline/origem/listar";

  return (
    <AsyncWithSearch id="select-origem" label={intl.formatMessage({ defaultMessage: "Origem" })} url={URL} {...props} />
  );
}

export default SelectOrigem;
